export const translations = {
  it: {
    nav: { servizi: "Servizi", lavori: "Lavori", recensioni: "Recensioni", chiSiamo: "Chi Siamo", contatti: "Contatti", cta: "Preventivo gratuito", qrHint: "Inquadra il QR con la fotocamera per aprire il sito sul telefono" },
    hero: {
      overline: "Impresa edile · Milano",
      line1: "Software per l'edilizia,",
      line2: "gestione cantieri",
      line3: "e preventivi rapidi.",
      subtitle: "Soluzioni per imprese edili e privati: ristrutturazioni, nuove costruzioni e restauri, con gestione cantieri e preventivi online. Ogni cantiere è una promessa mantenuta.",
      ctaQuote: "Richiedi un preventivo",
      ctaProjects: "Scopri i nostri lavori",
      scroll: "Scorri",
    },
    marquee: ["Ristrutturazioni", "Nuove Costruzioni", "Restauri Conservativi", "Cappotti Termici", "Efficienza Energetica", "Direzione Lavori"],
    home: {
      servicesOverline: "Cosa facciamo",
      servicesTitle: "Soluzioni per imprese edili e privati",
      servicesDesc: "Dalla ristrutturazione alla nuova costruzione, fino al gestionale per i preventivi: quattro aree di intervento, un unico standard — l'eccellenza. Clicca su un servizio per esplorare tutti i dettagli.",
      projectsOverline: "I nostri lavori",
      projectsTitle: "Progetti che parlano da soli",
      projectsDesc: "Interni ed esterni di case ristrutturate in altissima definizione. Clicca su un progetto per vedere la scheda completa.",
      reviewsOverline: "Recensioni",
      reviewsTitle: "Chi ci ha scelto ci consiglia",
      reviewsDesc: "Le valutazioni più alte lasciate dai nostri clienti dopo la consegna dei lavori.",
      reviewsAll: "Leggi tutte le recensioni",
    },
    services: {
      "ristrutturazioni": {
        title: "Ristrutturazioni Chiavi in Mano",
        desc: "Dal rilievo iniziale alla consegna finale: un unico interlocutore per trasformare il tuo immobile senza stress.",
        features: ["Demolizioni e ricostruzioni interne", "Rifacimento impianti a norma", "Finiture e materiali di pregio", "Direzione lavori inclusa"],
      },
      "nuove-costruzioni": {
        title: "Nuove Costruzioni",
        desc: "Edifici residenziali e commerciali costruiti secondo i più alti standard antisismici ed energetici.",
        features: ["Strutture in cemento armato e acciaio", "Edilizia residenziale e commerciale", "Standard antisismici aggiornati", "Obiettivo classe energetica A"],
      },
      "cappotti": {
        title: "Cappotti Termici & Efficienza",
        desc: "Riqualificazione energetica completa: meno consumi, più comfort, valore crescente nel tempo.",
        features: ["Isolamento a cappotto minerale", "Integrazione fotovoltaico", "Gestione pratiche e bonus fiscali", "Certificazione energetica APE"],
      },
      "restauri": {
        title: "Restauri & Consolidamenti",
        desc: "Recupero conservativo di edifici storici con tecniche tradizionali e tecnologie d'avanguardia.",
        features: ["Restauro conservativo certificato", "Consolidamento strutturale", "Recupero facciate e stucchi", "Materiali tradizionali e biocompatibili"],
      },
      more: "Scopri di più",
      goTo: "Vai ai servizi",
      close: "Chiudi",
    },
    servicesPage: {
      overline: "Servizi",
      title: "Quattro modi per trasformare casa tua",
      desc: "Ristrutturazioni chiavi in mano, nuove costruzioni, efficienza energetica e restauro conservativo. Clicca su ogni servizio per scoprire cosa include.",
      imageAlt: "Bagno ristrutturato con finiture di pregio TecnoEdil",
    },
    projectsPage: {
      overline: "I nostri lavori",
      title: "Case ristrutturate, dentro e fuori",
      desc: "Interni ed esterni in altissima definizione: ville, attici, cucine, bagni e restauri. Filtra per ambiente e clicca su un progetto per aprire la scheda completa.",
      imageAlt: "Esterni di ville ristrutturate TecnoEdil",
      viewAll: "Vedi tutti i lavori",
    },
    filters: { Tutti: "Tutti", Esterni: "Esterni", Interni: "Interni", Cucine: "Cucine", Bagni: "Bagni", Restauro: "Restauro" },
    projects: {
      "proj-01": { title: "Villa Modernista all'Olgiata", category: "Ristrutturazione Completa", description: "Riqualificazione energetica in Classe A4, ampliamento volumetrico, piscina infinity integrata e facciate ventilate." },
      "proj-02": { title: "Penthouse Open Space Sempione", category: "Interni di Pregio", description: "Ristrutturazione totale degli interni con arredi su misura, camino minimalista integrato e travi in legno sbiancato." },
      "proj-03": { title: "Cucina con Isola a Posillipo", category: "Cucine & Living", description: "Isola centrale in quarzo e marmo, illuminazione architetturale a sospensione e domotica avanzata." },
      "proj-04": { title: "Rustico Moderno nel Chianti", category: "Restauro Conservativo", description: "Unione tra pietra tradizionale toscana recuperata ed elementi contemporanei in acciaio e vetro." },
      "proj-05": { title: "Bagno Spa a Porta Nuova", category: "Bagni di Design", description: "Rivestimento completo in marmo, lavabi sospesi in ceramica sartoriale e doccia emozionale a filo pavimento." },
      "proj-06": { title: "Loft Architetturale ai Navigli", category: "Conversione & Loft", description: "Conversione di ex spazio industriale in loft residenziale con scala scenografica in legno e struttura in acciaio." },
      "proj-07": { title: "Villa Panorama in Costa Smeralda", category: "Esterni & Solarium", description: "Ampliamento delle terrazze panoramiche, serramenti a totale scomparsa e solarium in pietra naturale." },
      "proj-08": { title: "Salone Open Living ad Albaro", category: "Interni Residenziali", description: "Luce naturale protagonista, pavimentazione in parquet di rovere e vetrate a tutt'altezza sul giardino." },
    },
    projectDetail: {
      back: "Torna a tutti i lavori",
      theProject: "Il progetto",
      extra: "Intervento curato dal nostro team tecnico in ogni fase: dal rilievo iniziale alla consegna chiavi in mano, con direzione lavori dedicata e materiali selezionati.",
      surface: "Superficie",
      scope: "Ambito",
      otherProjects: "Altri progetti",
    },
    beforeAfter: {
      overline: "Prima & Dopo",
      title: "La trasformazione, in uno slider",
      desc: "Trascina il cursore e confronta: da struttura originaria a residenza ristrutturata TecnoEdil, in altissima definizione.",
      before: "Prima · struttura originaria",
      after: "Dopo · ristrutturato TecnoEdil",
      aria: "Confronta prima e dopo",
    },
    chiSiamo: {
      overline: "Chi siamo",
      title: "Un'impresa, una parola d'ordine: solidità",
      desc: "Tecnici interni e maestranze proprie lavorano fianco a fianco con un unico obiettivo: il massimo, in ogni dettaglio. Non subappaltiamo la qualità.",
      imageAlt: "Cucina ristrutturata con strutture in cartongesso TecnoEdil",
      valuesOverline: "I nostri valori",
      valuesTitle: "Quello in cui crediamo, in ogni cantiere",
      valuesDesc: "Non promesse, ma metodo: quattro principi che guidano ogni nostro lavoro, dal sopralluogo alla consegna.",
      values: [
        { title: "Precisione tecnica", desc: "Rilievi, calcoli e dettagli esecutivi curati al millimetro, senza improvvisazioni in corso d'opera." },
        { title: "Trasparenza totale", desc: "Preventivi dettagliati voce per voce e cronoprogramma chiaro fin dal primo giorno." },
        { title: "Puntualità garantita", desc: "Tempi di consegna dichiarati all'inizio e rispettati fino all'ultimo giorno di cantiere." },
        { title: "Sicurezza prima di tutto", desc: "Cantieri a norma, personale formato e controlli costanti su ogni lavorazione." },
      ],
    },
    contact: {
      overline: "Contatti",
      title: "Parliamone. Il sopralluogo è gratuito.",
      desc: "Raccontaci il tuo progetto: ti risponderemo entro 24 ore lavorative con un primo confronto senza impegno.",
      imageAlt: "Interni ristrutturati TecnoEdil",
      labels: { sede: "Sede", telefono: "Telefono", email: "Email", orari: "Orari" },
      name: "Nome e cognome *",
      namePh: "Mario Rossi",
      email: "Email *",
      emailPh: "mario@esempio.it",
      phone: "Telefono *",
      phonePh: "+39 333 1234567",
      workType: "Tipo di lavoro *",
      area: "Metratura indicativa (m²)",
      areaPh: "Es. 120",
      message: "Il tuo progetto *",
      messagePh: "Descrivici brevemente cosa vorresti realizzare...",
      submit: "Invia richiesta di preventivo",
      sending: "Invio in corso...",
      workTypes: ["Ristrutturazione", "Nuova Costruzione", "Cappotto Termico / Efficienza", "Restauro", "Altro"],
      toastOk: "Richiesta inviata!",
      toastOkDesc: "Ti ricontatteremo entro 24 ore lavorative per fissare il sopralluogo gratuito.",
      toastErr: "Invio non riuscito",
      toastErrDesc: "Controlla i campi e riprova.",
    },
    reviews: {
      overline: "Recensioni",
      title: "La parola a chi ha scelto TecnoEdil",
      desc: "Leggi le esperienze dei nostri clienti e lascia la tua: bastano un commento e le stelle.",
      imageAlt: "Interno ristrutturato recensito dai clienti TecnoEdil",
      formTitle: "Lascia la tua recensione",
      name: "Il tuo nome *",
      namePh: "Mario Rossi",
      rating: "Valutazione *",
      comment: "Il tuo commento *",
      commentPh: "Racconta com'è andata...",
      submit: "Pubblica recensione",
      sending: "Invio in corso...",
      one: "recensione",
      many: "recensioni",
      loading: "Caricamento...",
      empty: "Nessuna recensione ancora: sii il primo a lasciarne una.",
      toastOk: "Grazie per la tua recensione!",
      toastErr: "Invio non riuscito",
      toastErrDesc: "Controlla i campi e riprova.",
      loadErr: "Errore nel caricamento delle recensioni",
    },
    cta: {
      overline: "Pronto a iniziare?",
      title: "Il tuo progetto merita mani esperte. Parliamone di persona.",
      desc: "Sopralluogo gratuito e senza impegno: ti rispondiamo entro 24 ore lavorative.",
      button: "Richiedi un preventivo",
    },
    footer: {
      tagline: "Costruzioni & Restauri d'Eccellenza. Precisione tecnica, materiali selezionati e cantieri gestiti con trasparenza assoluta.",
      nav: "Navigazione",
      contacts: "Contatti",
      company: "Dati Aziendali",
      rights: "Tutti i diritti riservati.",
      backTop: "Torna su",
    },
  },
  en: {
    nav: { servizi: "Services", lavori: "Projects", recensioni: "Reviews", chiSiamo: "About Us", contatti: "Contact", cta: "Free quote", qrHint: "Scan the QR code with your camera to open the site on your phone" },
    hero: {
      overline: "Construction company · Milan",
      line1: "Construction software,",
      line2: "site management",
      line3: "and fast quoting.",
      subtitle: "Solutions for construction companies and homeowners: renovations, new builds and restorations, with online site management and quoting. Every site is a promise kept.",
      ctaQuote: "Request a quote",
      ctaProjects: "See our work",
      scroll: "Scroll",
    },
    marquee: ["Renovations", "New Builds", "Conservative Restoration", "Thermal Insulation", "Energy Efficiency", "Site Management"],
    home: {
      servicesOverline: "What we do",
      servicesTitle: "Solutions for construction companies and homeowners",
      servicesDesc: "From renovations to new builds, right through to the quote management tool: four areas of intervention, one single standard — excellence. Click a service to explore all the details.",
      projectsOverline: "Our work",
      projectsTitle: "Projects that speak for themselves",
      projectsDesc: "Interiors and exteriors of renovated homes in ultra-high definition. Click a project to see its full page.",
      reviewsOverline: "Reviews",
      reviewsTitle: "Those who chose us, recommend us",
      reviewsDesc: "The highest ratings left by our clients after project delivery.",
      reviewsAll: "Read all reviews",
    },
    services: {
      "ristrutturazioni": {
        title: "Turnkey Renovations",
        desc: "From the initial survey to final delivery: one point of contact to transform your property, stress-free.",
        features: ["Interior demolition and rebuilding", "Compliant systems renewal", "Premium finishes and materials", "Site management included"],
      },
      "nuove-costruzioni": {
        title: "New Builds",
        desc: "Residential and commercial buildings constructed to the highest seismic and energy standards.",
        features: ["Reinforced concrete and steel structures", "Residential and commercial construction", "Up-to-date seismic standards", "Targeting energy class A"],
      },
      "cappotti": {
        title: "Thermal Insulation & Efficiency",
        desc: "Complete energy upgrades: lower consumption, more comfort, value that grows over time.",
        features: ["Mineral external wall insulation", "Integrated photovoltaics", "Grants and tax paperwork handled", "EPC energy certification"],
      },
      "restauri": {
        title: "Restoration & Consolidation",
        desc: "Conservative restoration of historic buildings with traditional techniques and cutting-edge technology.",
        features: ["Certified conservative restoration", "Structural consolidation", "Historic facades and stucco recovery", "Traditional, biocompatible materials"],
      },
      more: "Learn more",
      goTo: "Go to services",
      close: "Close",
    },
    servicesPage: {
      overline: "Services",
      title: "Four ways to transform your home",
      desc: "Turnkey renovations, new builds, energy efficiency and conservative restoration. Click each service to see what it includes.",
      imageAlt: "Bathroom renovated with premium TecnoEdil finishes",
    },
    projectsPage: {
      overline: "Our work",
      title: "Renovated homes, inside and out",
      desc: "Interiors and exteriors in ultra-high definition: villas, penthouses, kitchens, bathrooms and restorations. Filter by room and click a project to open its full page.",
      imageAlt: "Exteriors of TecnoEdil renovated villas",
      viewAll: "See all projects",
    },
    filters: { Tutti: "All", Esterni: "Exteriors", Interni: "Interiors", Cucine: "Kitchens", Bagni: "Bathrooms", Restauro: "Restoration" },
    projects: {
      "proj-01": { title: "Modernist Villa in Olgiata", category: "Full Renovation", description: "A4 energy upgrade, volumetric extension, integrated infinity pool and ventilated facades." },
      "proj-02": { title: "Sempione Open-Space Penthouse", category: "Premium Interiors", description: "Full interior renovation with bespoke furniture, integrated minimalist fireplace and whitewashed wooden beams." },
      "proj-03": { title: "Island Kitchen in Posillipo", category: "Kitchens & Living", description: "Central quartz and marble island, architectural pendant lighting and advanced home automation." },
      "proj-04": { title: "Modern Farmhouse in Chianti", category: "Conservative Restoration", description: "Reclaimed traditional Tuscan stone meets contemporary steel and glass elements." },
      "proj-05": { title: "Spa Bathroom in Porta Nuova", category: "Designer Bathrooms", description: "Full marble cladding, bespoke suspended ceramic basins and a flush floor-level sensory shower." },
      "proj-06": { title: "Navigli Architectural Loft", category: "Conversion & Loft", description: "Former industrial space converted into a residential loft with a scenic wooden staircase and steel structure." },
      "proj-07": { title: "Panorama Villa in Costa Smeralda", category: "Exteriors & Solarium", description: "Panoramic terrace extension, fully concealed sliding windows and a natural-stone solarium." },
      "proj-08": { title: "Open Living Room in Albaro", category: "Residential Interiors", description: "Natural light takes centre stage, oak parquet flooring and full-height glazing onto the garden." },
    },
    projectDetail: {
      back: "Back to all projects",
      theProject: "The project",
      extra: "Every phase handled by our technical team: from the initial survey to turnkey delivery, with dedicated site management and selected materials.",
      surface: "Surface",
      scope: "Scope",
      otherProjects: "More projects",
    },
    beforeAfter: {
      overline: "Before & After",
      title: "The transformation, in one slider",
      desc: "Drag the handle and compare: from the original structure to a TecnoEdil-renovated home, in high definition.",
      before: "Before · original structure",
      after: "After · TecnoEdil renovation",
      aria: "Compare before and after",
    },
    chiSiamo: {
      overline: "About us",
      title: "One company, one watchword: solidity",
      desc: "In-house engineers, architects and craftsmen work side by side with a single goal: the best, in every detail. We don't subcontract quality.",
      imageAlt: "Kitchen renovated with TecnoEdil drywall structures",
      valuesOverline: "Our values",
      valuesTitle: "What we believe in, on every site",
      valuesDesc: "Not promises, but method: four principles guiding every job, from survey to handover.",
      values: [
        { title: "Technical precision", desc: "Surveys, calculations and executive details handled to the millimetre, with no improvisation on site." },
        { title: "Total transparency", desc: "Quotes itemised line by line and a clear schedule from day one." },
        { title: "Guaranteed punctuality", desc: "Delivery times declared upfront and met until the very last day on site." },
        { title: "Safety first", desc: "Compliant sites, trained staff and constant checks on every task." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Let's talk. The site survey is free.",
      desc: "Tell us about your project: we'll reply within 24 working hours with a first no-obligation consultation.",
      imageAlt: "TecnoEdil renovated interiors",
      labels: { sede: "Office", telefono: "Phone", email: "Email", orari: "Hours" },
      name: "Name and surname *",
      namePh: "John Smith",
      email: "Email *",
      emailPh: "john@example.com",
      phone: "Phone *",
      phonePh: "+39 333 1234567",
      workType: "Type of work *",
      area: "Indicative area (m²)",
      areaPh: "E.g. 120",
      message: "Your project *",
      messagePh: "Briefly describe what you'd like to build...",
      submit: "Send quote request",
      sending: "Sending...",
      workTypes: ["Renovation", "New Build", "Thermal Insulation / Efficiency", "Restoration", "Other"],
      toastOk: "Request sent!",
      toastOkDesc: "We'll contact you within 24 working hours to schedule the free survey.",
      toastErr: "Could not send",
      toastErrDesc: "Check the fields and try again.",
    },
    reviews: {
      overline: "Reviews",
      title: "In the words of those who chose TecnoEdil",
      desc: "Read our clients' experiences and leave yours: all it takes is a comment and a star rating.",
      imageAlt: "Renovated interior reviewed by TecnoEdil clients",
      formTitle: "Leave your review",
      name: "Your name *",
      namePh: "John Smith",
      rating: "Rating *",
      comment: "Your comment *",
      commentPh: "Tell us how it went...",
      submit: "Publish review",
      sending: "Publishing...",
      one: "review",
      many: "reviews",
      loading: "Loading...",
      empty: "No reviews yet: be the first to leave one.",
      toastOk: "Thanks for your review!",
      toastErr: "Could not send",
      toastErrDesc: "Check the fields and try again.",
      loadErr: "Error loading reviews",
    },
    cta: {
      overline: "Ready to start?",
      title: "Your project deserves expert hands. Let's talk in person.",
      desc: "Free, no-obligation site survey: we reply within 24 working hours.",
      button: "Request a quote",
    },
    footer: {
      tagline: "Construction & Excellence Restorations. Technical precision, selected materials and sites managed with absolute transparency.",
      nav: "Navigation",
      contacts: "Contact",
      company: "Company Details",
      rights: "All rights reserved.",
      backTop: "Back to top",
    },
  },
};
